import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-terracotta text-cream hover:bg-terracotta-dark shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-sage text-cream hover:bg-sage-dark shadow-md hover:shadow-lg',
    outline: 'border-2 border-terracotta text-terracotta hover:bg-terracotta/10'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-213">
      {children}
    </motion.button>;
}